export default __webpack_public_path__ + "static/media/a017-1.bae0b4e9.svg";